import React from 'react';
// @ts-ignore
import { FormGroup, Heading, Loader } from 'arag-ui-lib';
// @ts-ignore
import _ from 'lodash';
import ConfirmationDialog from '../general/confirmationDialog/confirmationDialog';
import ClaimFormContainer from '../../containers/claimForm/claimFormContainer';

import { ObjectOfAny } from '../../reducers/types';
import { useTranslation } from 'react-i18next';

type Props = {
    policyTypes: { code: string; name: string }[] | any;
    claimCategories: { code: string; name: string }[];
    formTypes: { code: string; name: string }[];
    answers: ObjectOfAny;
    handleClaimBasicQuestionChange: (evt: {
        target: { name: string; value: string };
    }) => void;
    handleConfirm: () => void;
    closeConfirmationModal: () => any;
    confirmationModalOpen: boolean;
    arePoliciesLoading: boolean;
    areClaimCategoriesLoading: boolean;
    areFormTypesLoading: boolean;
    fetchingQuestionGroupSteps: boolean;
    hasRouteChangedByModal: boolean;
    setHasRouteChangedByModal: (b: boolean) => void;
    refillClaimId: string;
    setQuestionGroupsStepsLoading: (b: boolean) => void;
    prevFetchingQuestionGroupSteps: boolean | undefined;
    loadingNoSubmittedDraft: boolean;
    questionGroupsStepsLoading: boolean;
};
const Claim = (props: Props) => {
    const {
        policyTypes,
        claimCategories,
        formTypes,
        answers,
        handleClaimBasicQuestionChange,
        handleConfirm,
        closeConfirmationModal,
        confirmationModalOpen,
        arePoliciesLoading,
        areClaimCategoriesLoading,
        areFormTypesLoading,
        fetchingQuestionGroupSteps,
        hasRouteChangedByModal,
        setHasRouteChangedByModal,
        refillClaimId,
        setQuestionGroupsStepsLoading,
        prevFetchingQuestionGroupSteps,
        loadingNoSubmittedDraft,
        questionGroupsStepsLoading,
    } = props;
    const { t } = useTranslation();
    return (
        <div>
            <ConfirmationDialog
                executeAction={handleConfirm}
                handleClose={closeConfirmationModal}
                action={t('resetFormconfirmAction')}
                title={t('resetForm')}
                isOpen={confirmationModalOpen}
            />
            <Heading variant="h2" title={t('newClaim')} />
            <FormGroup
                labelSize={'col-sm-6'}
                inputSize={'col-sm-5'}
                label={t('isYourPolicyCommercialOrPersonalOrLandlord')}
                variant={'select'}
                infoText={refillClaimId ? t<string>('refillClaim') : null}
                inputProps={{
                    name: 'policyType',
                    options: [
                        { key: '', label: '' },
                        ..._.map(
                            policyTypes,
                            (policyType: { code: string; name: string }) => ({
                                key: policyType.code,
                                label: policyType.name,
                            }),
                        ),
                    ],
                    onChange: handleClaimBasicQuestionChange,
                    value: answers.policyType,
                    isLoading:
                        arePoliciesLoading ||
                        areClaimCategoriesLoading ||
                        (areFormTypesLoading &&
                            Object.keys(claimCategories).length === 0) ||
                        loadingNoSubmittedDraft,
                    //disable inputs in cases: there are not submitted drafts or policyType/claimCategory/formTypes/questions which are fetching
                    disabled:
                        refillClaimId ||
                        loadingNoSubmittedDraft ||
                        arePoliciesLoading ||
                        areClaimCategoriesLoading ||
                        areFormTypesLoading ||
                        questionGroupsStepsLoading ||
                        fetchingQuestionGroupSteps,
                }}
            />
            {Object.keys(claimCategories).length > 0 && (
                <FormGroup
                    labelSize={'col-sm-6'}
                    inputSize={'col-sm-5'}
                    label={t('pleaseSelectTheAppropriateClaimCategory')}
                    variant={'select'}
                    infoText={refillClaimId ? t<string>('refillClaim') : null}
                    inputProps={{
                        name: 'claimCategory',
                        options: [
                            { key: '', label: '' },
                            ..._.map(
                                claimCategories,
                                (claimCategory: {
                                    code: string;
                                    name: string;
                                }) => ({
                                    key: claimCategory.code,
                                    label: claimCategory.name,
                                }),
                            ),
                        ],
                        onChange: handleClaimBasicQuestionChange,
                        value: answers.claimCategory,
                        isLoading:
                            areFormTypesLoading ||
                            (fetchingQuestionGroupSteps &&
                                Object.keys(formTypes).length === 0),
                        //disable inputs in cases: there are formTypes/questions/questionGroupSteps which are fetching
                        disabled:
                            refillClaimId ||
                            areFormTypesLoading ||
                            questionGroupsStepsLoading ||
                            fetchingQuestionGroupSteps,
                    }}
                />
            )}
            {Object.keys(formTypes).length > 0 && (
                <FormGroup
                    labelSize={'col-sm-6'}
                    inputSize={'col-sm-5'}
                    label={t('pleaseSelectTheAppropriateFormType')}
                    variant={'select'}
                    infoText={refillClaimId ? t<string>('refillClaim') : null}
                    inputProps={{
                        name: 'formType',
                        options: [
                            { key: '', label: '' },
                            ..._.map(
                                formTypes,
                                (formType: { code: string; name: string }) => ({
                                    key: formType.code,
                                    label: formType.name,
                                }),
                            ),
                        ],
                        onChange: handleClaimBasicQuestionChange,
                        value: answers.formType,
                        isLoading: fetchingQuestionGroupSteps,
                        //disable inputs in cases: there are  questions/questionGroupSteps which are fetching
                        disabled:
                            refillClaimId ||
                            questionGroupsStepsLoading ||
                            fetchingQuestionGroupSteps,
                    }}
                />
            )}
            {((!fetchingQuestionGroupSteps && prevFetchingQuestionGroupSteps) ||
                questionGroupsStepsLoading) && (
                <Loader variant={'inline'} label={t('loading')} />
            )}
            <br />
            <ClaimFormContainer
                hasRouteChangedByModal={hasRouteChangedByModal}
                setHasRouteChangedByModal={setHasRouteChangedByModal}
                fetchingQuestionGroupSteps={fetchingQuestionGroupSteps}
                questionGroupsStepsLoading={questionGroupsStepsLoading}
                setQuestionGroupsStepsLoading={setQuestionGroupsStepsLoading}
                prevFetchingQuestionGroupSteps={prevFetchingQuestionGroupSteps}
            />
        </div>
    );
};

export default Claim;
